<template>
  <div ref="container" class="fallback-hint-container position-relative" :data-attribute="field">
    <div class="input-group flex-nowrap" :class="validationClass">
      <input
        v-model="multiSelectValue"
        ref="input"
        :id="`attribute-multi-value-editor-wrapper-${field}-${language.languageCode}`"
        :readonly="true"
        class="form-control value-editor"
        v-tooltip="validationTooltipText" />
      <div class="input-group-append" v-if="attributeType && !disableMultiselect">
        <b-btn v-if="canWrite" ref="openbutton" type="button" @click="openDialog"><i class="mdp-CatalogNode"></i></b-btn>
      </div>
    </div>
    <multi-default-value-select-dialog
      v-if="showDialog"
      v-model:visible="showDialog"
      :defaultValues="(multiSelectData && multiSelectData.defaultValues) || source[language.languageCode]['defaultValues']"
      :valueList="source[language.languageCode].multiSelectAttributeValues"
      @valueList="onValueListUpdated($event)" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import authorizationProvider from "../../services/permissions/permissionEngine";
import MultiDefaultValueSelectDialog from "./MultiDefaultValueSelectDialog.vue";

export default {
  props: [
    "value",
    "source",
    "field",
    "language",
    "validationData",
    "attributeType",
    "attributeId",
    "dataType",
    "multiSelectData",
    "disableMultiselect",
    "authorizationContext",
    "readonly"
  ],
  data() {
    return {
      showDialog: false
    };
  },
  components: {
    MultiDefaultValueSelectDialog
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    onValueListUpdated(nv) {
      this.$emit("multiSelectValueUpdated", nv);
    }
  },
  computed: {
    ...mapState(["globalParameters"]),
    canWrite() {
      if (this.readonly === true) return false;

      if (this.authorizationContext) {
        return authorizationProvider.canWrite(this.authorizationContext);
      }
      return true;
    },
    multiSelectValue() {
      const values = this.source[this.language.languageCode].multiSelectAttributeValues || [];
      return values.map((x) => x[this.field]).join(this.globalParameters.MultiAttributeValueSeparator);
    },
    validationTooltipText() {
      const localValidationData = this.validationData;
      const feedback = localValidationData && !localValidationData.isValid && localValidationData.feedback ? localValidationData.feedback : "";
      const isValidationFeedbackEmpty = feedback == "" || feedback === undefined ? "" : " ";
      return feedback + isValidationFeedbackEmpty;
    },
    validationClass() {
      const localValidationData = this.validationData;
      return {
        "border-warning": localValidationData && !localValidationData.isValid && localValidationData.type === "warning",
        "border-danger": localValidationData && !localValidationData.isValid && localValidationData.type === "error"
      };
    }
  }
};
</script>
